import styled from "styled-components";
import { SwiperGamesListDefaultBox } from "./swiper-games-list.default.box";

export const SwiperGamesListMrGreenBox = styled(SwiperGamesListDefaultBox)`
    margin-top: 0;
`;